import { render } from "./playedSelector.vue?vue&type=template&id=2c036c42&ts=true"
import script from "./playedSelector.vue?vue&type=script&lang=ts"
export * from "./playedSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__